import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from './pages/ErrorBoundary/ErrorBoundary';
import GoogleMapsLoader from './pages/Carriers/GoogleMapsLoader';

ReactDOM.render(
  <React.Fragment>
    <ErrorBoundary>
      <GoogleMapsLoader>
        <App />
      </GoogleMapsLoader>
    </ErrorBoundary>
  </React.Fragment>,
  document.getElementById('root')
);

